import React, { useState } from 'react';
import {
  Accordion as ReactAccessibleAccordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import {
  SubAccordionContainer,
  SubAccordionTitle,
  SubAccordionContentBox,
  SubContent,
  StyledExpandMoreIcon,
  VideoBtn,
  VideoIcon,
} from './subAccordionStyle';
import { toAccordionId } from './accordionId';

const SubAccordion = ({ title, content, video }) => {
  const [isActive, setIsActive] = useState(false);
  // Valid HTML5 id for the uuid; used consistently in preExpanded / onChange so
  // the expand/collapse match still works (the visible label stays `title`).
  const itemId = toAccordionId(title);

  return (
    <SubAccordionContainer>
      <ReactAccessibleAccordion
        allowZeroExpanded
        preExpanded={isActive ? [itemId] : []}
        onChange={(uuids) => setIsActive(uuids.includes(itemId))}
      >
        <AccordionItem uuid={itemId}>
          <AccordionItemHeading>
            <SubAccordionTitle as={AccordionItemButton}>
              {title} <StyledExpandMoreIcon isActive={isActive} />
            </SubAccordionTitle>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <SubAccordionContentBox isActive={isActive}>
              <SubContent>{content}</SubContent>
              {video && (
                <VideoBtn isActive={isActive}>
                  <VideoIcon src="/img/video-circle.png" />
                  Video tutorial
                </VideoBtn>
              )}
            </SubAccordionContentBox>
          </AccordionItemPanel>
        </AccordionItem>
      </ReactAccessibleAccordion>
    </SubAccordionContainer>
  );
};

export default SubAccordion;
